// A replacement for { CSVLink } from 'react-csv' which properly escapes quotes
// (see https://microstartap3.atlassian.net/browse/TP3-3686 and
// https://github.com/react-csv/react-csv/issues/28 for details). Always use
// this instead of the regular CSVLink.
import React, { memo, forwardRef } from 'react'
import { CSVLink as CSVLinkOriginal } from 'react-csv'

import { recursivelyReplaceSubstringInAllStringsInObject } from '../../utils'

export const CSVLink = memo(
  forwardRef(({ headers, data, ...rest }, ref) => {
    const substring = '"'
    const replacement = '""'

    const safeHeaders = recursivelyReplaceSubstringInAllStringsInObject({
      obj: headers,
      substring,
      replacement,
      checkObjectKeys: true,
    })

    const safeData = recursivelyReplaceSubstringInAllStringsInObject({
      obj: data,
      substring,
      replacement,
      checkObjectKeys: true,
    })

    return <CSVLinkOriginal {...rest} headers={safeHeaders} data={safeData} ref={ref} />
  })
)
